import { useProducts } from "./hooks/useProducts";
import ProductCard from "./products/card";
import CardSkeleton from "./cardSkeleton";
const AllProducts = ({ searchQuery }) => {
    const { products, error, loadMore, hasMore, isFetchingNextPage,isLoadInitially } = useProducts({
        page: 1,
        name: searchQuery
    });

    return (
        <div className="w-full py-4">
            <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6">
                {isLoadInitially?
                    Array.from({length:12}).map((_, i) =>
                    <CardSkeleton key={i}/>
                        )
                :products.map(product => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>
            {hasMore && (
                <div className="text-center mt-6">
                    <button
                        onClick={() => loadMore()}
                        disabled={isFetchingNextPage}
                        className="px-4 py-2 text-white rounded hover:bg-yellow-600 !bg-yellow-500 outline-0 border-none">
                        {isFetchingNextPage ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}
            {error && <div className="text-red-500 text-center mt-4">{error}</div>}
        </div>
    );
}

export default AllProducts;